enum ObstetricalFileContributionType {
    NewPregnancy,
    FollowUp,
    Postnatal
}

export { ObstetricalFileContributionType };
